import React from 'react';
import  Robotics2024  from 'views/Robotics2024';

const ClassAssemblyPage = () => {
    return <Robotics2024/>;
  };
  
  export default ClassAssemblyPage;